var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClose = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Close")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/lined/close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,22.5857864 L33.6637926,12.9219937 C34.0543169,12.5314694 34.6874819,12.5314694 35.0780062,12.9219937 C35.4685305,13.312518 35.4685305,13.945683 35.0780062,14.3362073 L25.4142135,24 L35.0780062,33.6637926 C35.4685305,34.0543169 35.4685305,34.6874819 35.0780062,35.0780062 C34.6874819,35.4685305 34.0543169,35.4685305 33.6637926,35.0780062 L24,25.4142135 L14.3362073,35.0780062 C13.945683,35.4685305 13.312518,35.4685305 12.9219937,35.0780062 C12.5314694,34.6874819 12.5314694,34.0543169 12.9219937,33.6637926 L22.5857864,24 L12.9219937,14.3362073 C12.5314694,13.945683 12.5314694,13.312518 12.9219937,12.9219937 C13.312518,12.5314694 13.945683,12.5314694 14.3362073,12.9219937 L24,22.5857864 Z",
    id: "Path",
    fill: "#0A1428",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.c8a70143.svg";
export { ForwardRef as ReactComponent };